module.exports = __webpack_public_path__ + "static/media/close-circle.43dd8c02.svg";